// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__1Z-VB","header":"Messages_header__3Xyqb"};